import { render, staticRenderFns } from "./ChangeSituation.vue?vue&type=template&id=3f22d2a2&scoped=true&"
import script from "./ChangeSituation.vue?vue&type=script&lang=js&"
export * from "./ChangeSituation.vue?vue&type=script&lang=js&"
import style0 from "./ChangeSituation.vue?vue&type=style&index=0&id=3f22d2a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f22d2a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('3f22d2a2', component.options)
    } else {
      api.reload('3f22d2a2', component.options)
    }
    module.hot.accept("./ChangeSituation.vue?vue&type=template&id=3f22d2a2&scoped=true&", function () {
      api.rerender('3f22d2a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/student-profile/components/change_situation/ChangeSituation.vue"
export default component.exports